import angular from 'angular';
import travelExpenseDetailsComponent from './travel-expense-details.component';

let travelExpenseDetailsModule = angular.module('travelExpenseDetails', [])
  .component('travelExpenseDetails', travelExpenseDetailsComponent);

export default travelExpenseDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense-details/travel-expense-details.js